(() => {
  const elementName = 'abok-back-to-top';
  if (customElements.get(elementName)) return;

  class AbokBackToTop extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;

      this.initialized = true;
      this.abortController = new AbortController();
      this.reducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.button = this.querySelector('[data-back-to-top-button]');
      this.scrollFrame = null;

      const options = { signal: this.abortController.signal };
      window.addEventListener('scroll', this.queueVisibilityUpdate, { ...options, passive: true });
      window.addEventListener('resize', this.handleResize, { ...options, passive: true });
      this.button?.addEventListener('click', this.handleClick, options);

      this.observeOverlays();
      this.hidden = false;
      this.updateVisibility();
      this.updateOverlayOffset();
    }

    disconnectedCallback() {
      this.abortController?.abort();
      this.overlayObserver?.disconnect();
      this.nativeBannerObserver?.disconnect();
      this.nativeBannerDiscoveryObserver?.disconnect();
      window.clearTimeout(this.nativeBannerDiscoveryTimer);
      if (this.scrollFrame !== null) window.cancelAnimationFrame(this.scrollFrame);
      this.initialized = false;
    }

    get revealThreshold() {
      return Math.max(480, window.innerHeight * 0.75);
    }

    queueVisibilityUpdate = () => {
      if (this.scrollFrame !== null) return;

      this.scrollFrame = window.requestAnimationFrame(() => {
        this.scrollFrame = null;
        this.updateVisibility();
      });
    };

    handleResize = () => {
      this.updateVisibility();
      this.updateOverlayOffset();
    };

    handleClick = () => {
      window.scrollTo({
        top: 0,
        behavior: this.reducedMotionQuery.matches ? 'auto' : 'smooth',
      });
      this.button?.blur();
    };

    updateVisibility() {
      this.dataset.visible = String(window.scrollY > this.revealThreshold);
    }

    observeOverlays() {
      this.stickyCart = document.querySelector('abok-sticky-add-to-cart');
      const overlays = [this.stickyCart].filter(Boolean);
      this.observeNativePrivacyBanner();
      if (!overlays.length) return;

      this.overlayObserver = new MutationObserver(this.updateOverlayOffset);
      overlays.forEach((overlay) => {
        this.overlayObserver.observe(overlay, {
          attributes: true,
          attributeFilter: ['data-visible', 'hidden'],
        });
      });

    }

    observeNativePrivacyBanner() {
      if (this.attachNativePrivacyBanner()) return;

      this.nativeBannerDiscoveryObserver = new MutationObserver(() => {
        if (!this.attachNativePrivacyBanner()) return;

        this.nativeBannerDiscoveryObserver.disconnect();
        window.clearTimeout(this.nativeBannerDiscoveryTimer);
      });
      this.nativeBannerDiscoveryObserver.observe(document.body, { childList: true, subtree: true });
      this.nativeBannerDiscoveryTimer = window.setTimeout(
        () => this.nativeBannerDiscoveryObserver?.disconnect(),
        5000
      );
    }

    attachNativePrivacyBanner() {
      const banner = document.querySelector('#shopify-pc__banner');
      if (!banner) return false;

      this.nativePrivacyBanner = banner;
      this.nativeBannerObserver = new MutationObserver(this.updateOverlayOffset);
      this.nativeBannerObserver.observe(banner, {
        attributes: true,
        attributeFilter: ['class', 'hidden', 'style'],
      });
      this.updateOverlayOffset();
      return true;
    }

    hasVisibleNativePrivacyBanner() {
      if (!this.nativePrivacyBanner || this.nativePrivacyBanner.hidden) return false;

      const styles = window.getComputedStyle(this.nativePrivacyBanner);
      return styles.display !== 'none' && styles.visibility !== 'hidden';
    }

    updateOverlayOffset = () => {
      this.dataset.blocked = String(this.hasVisibleNativePrivacyBanner());

      const stickyIsVisible = Boolean(
        this.stickyCart?.dataset.visible === 'true' && !this.stickyCart?.hasAttribute('hidden')
      );
      const stickyHeight = stickyIsVisible ? Math.ceil(this.stickyCart.getBoundingClientRect().height) : 0;
      this.style.setProperty('--abok-back-to-top-overlay-offset', `${stickyHeight ? stickyHeight + 16 : 0}px`);
    };
  }

  customElements.define(elementName, AbokBackToTop);
})();
